var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.$t("scrap-agent.login"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("modal:close")
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-mode" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              alt: "google",
                              src: _vm.syncedChannelConnect.channelImageUri,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.syncedChannelConnect.channelName)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.syncedChannelConnect.channelType == "ONE_DRIVE"
                      ? _c("button", {
                          staticClass: "microsoft-btn",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("scrap-agent.login-common.loginMS")
                            ),
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.openGooglePopup.apply(null, arguments)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.syncedChannelConnect.channelType === "DROP_BOX"
                      ? _c(
                          "button",
                          {
                            staticClass: "google-btn",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.openGooglePopup.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("scrap-agent.login-common.login")
                                ) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.syncedChannelConnect.channelType === "GOOGLE_DRIVE"
                      ? _c(
                          "button",
                          {
                            staticClass: "google-btn",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.openGooglePopup.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "google-icon",
                              attrs: {
                                src: "https://www.svgrepo.com/show/475656/google-color.svg",
                                alt: "Google Logo",
                              },
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("scrap-agent.login-common.loginGG")
                                ) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }